// Single source of truth for org-prefix handling on User Chats hashtags.
// Groups are stored WITHOUT the prefix; each surface re-adds it for display.

export const normalizeOrgPrefix = (rawPrefix) => {
    const prefix = String(rawPrefix || '').trim();
    if (prefix.endsWith('-')) {
        return prefix.slice(0, -1);
    }
    return prefix;
};

export const getOrgPrefix = (user) => {
    const org = user && user.profile && user.profile.organizationId;
    return normalizeOrgPrefix(org && org.smsGroupPrefix);
};

// Display form: prepend the prefix unless the name already carries it.
export const withHashtagPrefix = (rawName, rawPrefix) => {
    const name = String(rawName || '').toLowerCase();
    const prefix = normalizeOrgPrefix(rawPrefix);
    if (!prefix) {
        return name;
    }
    if (name.startsWith(prefix.toLowerCase() + '-')) {
        return name;
    }
    return prefix + '-' + name;
};

// Storage form: drop any leading '#' and the org prefix.
// Requires the trailing dash so a name that merely starts with those letters survives.
export const stripHashtagPrefix = (rawName, rawPrefix) => {
    const name = String(rawName || '').replace(/^#+/, '');
    const prefix = normalizeOrgPrefix(rawPrefix);
    if (prefix && name.toLowerCase().startsWith(prefix.toLowerCase() + '-')) {
        return name.slice(prefix.length + 1);
    }
    return name;
};
